import { HttpInterceptorFn } from "@angular/common/http";
import { getCookie } from '@shared/utils/cookie';


export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const csrftoken = getCookie('csrftoken') || null;
    if (!csrftoken) { return next(req); }

    const newReq = req.clone({
        setHeaders: {
            'X-CSRFToken': csrftoken
        }
    });

    return next(newReq);
};